// 0 - Sunday
export const ALL_DAYS = [0, 1, 2, 3, 4, 5, 6];

export default function (instance, calendarData) {
  const workingHours = calendarData.showTime;
  const workingDays = calendarData.showDay;

  ALL_DAYS.forEach(dayOfWeekNumber => {
    if (workingDays.includes(dayOfWeekNumber)) {
      instance.setWorkTime({ day: dayOfWeekNumber, hours: workingHours });
    } else {
      instance.setWorkTime({ day: dayOfWeekNumber, hours: false });
    }
  });

  return instance;
}
